// Généré par npm run build:phonetics : les rimes les plus fréquentes parmi les noms de GLÀFF
// (CC BY-SA 3.0), avec un nom exemple. Ne pas modifier à la main.
export const FREQUENT_RHYMES: readonly { rhyme: string; example: string }[] = [
  {
    "rhyme": "e",
    "example": "année"
  },
  {
    "rhyme": "ɔ̃",
    "example": "formation"
  },
  {
    "rhyme": "i",
    "example": "vie"
  },
  {
    "rhyme": "ɑ̃",
    "example": "ans"
  },
  {
    "rhyme": "œʁ",
    "example": "heure"
  },
  {
    "rhyme": "aʒ",
    "example": "page"
  },
  {
    "rhyme": "ɛʁ",
    "example": "commentaire"
  },
  {
    "rhyme": "a",
    "example": "droit"
  },
  {
    "rhyme": "o",
    "example": "travaux"
  },
  {
    "rhyme": "ism",
    "example": "organismes"
  },
  {
    "rhyme": "øz",
    "example": "employeuses"
  },
  {
    "rhyme": "ɛ̃",
    "example": "point"
  },
  {
    "rhyme": "aʁ",
    "example": "histoire"
  },
  {
    "rhyme": "ist",
    "example": "liste"
  },
  {
    "rhyme": "ɛ",
    "example": "projet"
  },
  {
    "rhyme": "ɛt",
    "example": "tête"
  },
  {
    "rhyme": "ik",
    "example": "politique"
  },
  {
    "rhyme": "in",
    "example": "origine"
  },
  {
    "rhyme": "yʁ",
    "example": "mesure"
  },
  {
    "rhyme": "ɑ̃s",
    "example": "sciences"
  },
  {
    "rhyme": "is",
    "example": "service"
  },
  {
    "rhyme": "ɛl",
    "example": "appel"
  },
  {
    "rhyme": "it",
    "example": "site"
  },
  {
    "rhyme": "ɛn",
    "example": "semaine"
  },
  {
    "rhyme": "al",
    "example": "salle"
  },
  {
    "rhyme": "ɑ̃t",
    "example": "vente"
  },
  {
    "rhyme": "ɔl",
    "example": "école"
  },
  {
    "rhyme": "ɔm",
    "example": "homme"
  },
  {
    "rhyme": "id",
    "example": "guide"
  },
  {
    "rhyme": "y",
    "example": "début"
  }
];
